export default {
  methods: {
    onUploadFile (file, type) {
      let isLt10M = file.raw.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }

      let formData = new FormData()
      formData.append('file', file.raw)
      formData.append('collection_type', 9) // 客户管理
      formData.append('type', type) // 批量类型
      formData.append('file_type', 1) // 文件类型:上传excel

      request.common('batchCreateCustomerReceiptInfo', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.$options.name === 'CustomerBatchTable'
          ? this.onRefresh()
          : this.$router.push('/customer/batch-table')
      })
    },

    downCustomerInvoiceUploadTpl () {
      let demo = [{
        'customer_id': '客户名称/客户编号',
        'company': '开票信息',
        'bank_info': '开票信息',
        'address': '开票信息',
        'customer_num': '开票信息',
      }]
      const fileHeader = [
        {key: 'customer_id', text: '客户编号'},
        {key: 'company', text: '公司名称'},
        {key: 'bank_info', text: '开户行及账号'},
        {key: 'address', text: '地址及电话'},
        {key: 'customer_num', text: '纳税人识别号'},
      ]
      this.$export('批量更新开票信息模板', demo, {fileHeader})
    },

    closeCustomerInvoiceUploadDialog () {
      this.uploadDialogVisible = false
    },

    showCustomerInvoiceUploadDialog () {
      this.uploadDialogVisible = true
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/customer/customer.mixins.js